module.exports = __webpack_public_path__ + "static/media/plus.f8a2e155.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/plus.svg
// module id = 228
// module chunks = 0